import React from "react"
import Helmet from "react-helmet"
// import {NO_INDEX} from '../utils/bt-constant'

export default function SEO({context = {}}) {    
    const meta = []
     /* TODO: remove NO_INDEX from condition once the redirect (BT domain to PP domain) ticket is executed.
          This is to make sure that link to page is not searchable by search engine
          */
    if(context.templateData && context.templateData.attributes && context.templateData.attributes.noindex)
        meta.push({name: `robots`, content:`noindex`})
    if(context.templateData && context.templateData.attributes && context.templateData.attributes.meta_description) {
        const description = context.templateData.attributes.meta_description
        meta.push({name: `description`, content: description})
    }
    meta.push({name: 'google-site-verification', content: 'vFON0Wga-luQ_6VzKxCNLqFMYb49GWhusn2yncPzvuA'})
    meta.push({name: 'google-site-verification', content: 'RFPmZpOX4AnxXaCgJE_8id0ZOqBOgP0F9hA1FHxYDv8'})
    const link = []
    link.push({href: 'https://www.paypalobjects.com/btdevdoc/braintree/img/favicon.png', rel:`icon`, type:`image/png`})
    return (
        <Helmet 
            htmlAttributes = {{lang:'en', class: 'is-modern'}}
            title = {context.title}
            meta = {meta}
            link = {link}  
        />
    )
}
